import moment from 'moment';
import { getCalculationDetails } from './Pricing/getCalculationDetails';

export function calculateTotalPrice({ listingData, listBlockedDates, serviceFees, base, rates, guests, formatMessage, toCurrency }) {
  let startDate = null, endDate = null, dates = listingData?.dates;
  if (dates) {
    const dateParts = dates.split(" AND ");
    if (dateParts?.length === 2) {
      startDate = moment(dateParts[0].replace(/[']/g, '').trim(' '));
      endDate = moment(dateParts[1].replace(/[']/g, '').trim(' '));
    }
  }

  const specialPricing = listBlockedDates
    .filter(entry => entry.calendarStatus === "available")
    .map(entry => ({
      blockedDates: moment(entry?.blockedDates).format('DD/MM/YYYY'),
      isSpecialPrice: entry?.isSpecialPrice,
      dayStatus: entry?.dayStatus
    }));

  // Transform serviceFees from GraphQL array to expected object format
  let transformedServiceFees = {};
  if (serviceFees && serviceFees.length > 0) {
    const fee = serviceFees[0];
    transformedServiceFees = {
      guest: {
        type: fee.guestType,
        value: fee.guestValue,
        currency: fee.currency
      },
      host: {
        type: fee.hostType,
        value: fee.hostValue,
        currency: fee.currency
      }
    };
  }

  const { guestServiceFee, priceForDays, isAverage, discount, dayDifference, oneTotalPrice, extraGuestFeeAmount, extraGuestCount
  } = getCalculationDetails({
    startDate,
    basePrice: listingData?.basePrice,
    cleaningPrice: listingData?.cleaningPrice,
    monthlyDiscount: listingData?.monthlyDiscount,
    weeklyDiscount: listingData?.weeklyDiscount,
    customDiscounts: listingData?.customDiscounts,
    extraGuestThreshold: listingData?.extraGuestThreshold,
    extraGuestFee: listingData?.extraGuestFee,
    weekendPrice: listingData?.weekendPrice,
    guests,
    formatMessage,
    serviceFees: transformedServiceFees,
    specialPricing,
    tax: listingData?.tax || 0,
    currency: listingData?.currency,
    endDate,
    base,
    rates,
    toCurrency
  });


  return {
    oneTotalPrice,
    isAverage,
    dayDifference,
    isDayTotal: priceForDays,
    discount,
    cleaningPrice: listingData?.cleaningPrice,
    serviceFee: guestServiceFee,
    currency: listingData?.currency,
    extraGuestFeeAmount,
    extraGuestCount
  };
}